<template>
  <div>
    <Loading text="Loading redemption page..." v-if="!loadStatus" />

    <template v-else>
      <div class="holder">
        <h2 class="page-titles">{{ groupOrderDetails.name }}</h2>
      </div>

      <GroupOrderHeaderBanner
        :title="'Add customizations'"
        :headerText="'Custom Settings'"
        :currentStep="creatingGroupOrderStep"
        @onPrevStep="$router.go(-1)"
        @onNextStep="handleStepValidation"
      />
      <div class="info-container">
        <GroupOrderCoverPageSettings
          ref="GroupOrderCoverPageSettings"
          :isDisabled="true"
        />
        <AdditionalInstruction ref="AdditionalInstruction" :isDisabled="true" />
        <DataCollection ref="DataCollection" :isDisabled="true" />
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { layouts, progressStatus } from '../../helpers'
import GroupOrderHeaderBanner from './GroupOrderHeaderBanner'
import GroupOrderCoverPageSettings from './CustomSettings/GroupOrderCoverPageSettings'
import AdditionalInstruction from './CustomSettings/AdditionalInstruction'
import DataCollection from './CustomSettings/DataCollection'
export default {
  name: 'GroupOrderInfo',
  props: ['id'],
  data() {
    return {
      customFields: [],
      isVisible: false,
      passwordValue: 'no-password',
      password: '',
      redemptionDescription: 'default-description',
      redemptionTitle: 'default-title',
      redemptionSubTitle: 'default-sub-title',
      customDescription: '',
      customTitle: '',
      customSubTitle: '',
      allowed_domains: [],
      updatingDomain: false,
      valid: {
        password: false,
        title: false,
        sub_title: false,
        description: false
      },
      customTitleMaxCharacters: 10,
      customDescriptionMaxCharacters: 100,
      customSubTitleMaxCharacters: 20,
      currentCustomSettingsStep: 1
    }
  },

  created() {
    this.$store.dispatch('groupOrder/getGroupOrder', this.id)
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    this.$store.commit('groupOrder/CREATING_GROUP_ORDER_STEP', 5)
  },
  components: {
    GroupOrderHeaderBanner,
    GroupOrderCoverPageSettings,
    AdditionalInstruction,
    DataCollection
  },
  methods: {
    addCustomField() {
      this.customFields.push({ name: '', type: 'text' })
    },

    updateGroupOrder() {
      this.$store.dispatch('groupOrder/updateGroupOrder', {
        customFields: [
          ...this.groupOrderDetails.customFields,
          ...this.customFields
        ],
        redirect: false,
        showPrices: this.groupOrderDetails.showPrices,
        password: this.password,
        passwordProtected: this.passwordValue === 'password' ? true : false,
        redemptionTitle: this.customTitle,
        redemptionSubTitle: this.customSubTitle,
        redemptionDescription: this.customDescription,
        allowedDomains: this.allowed_domains,
        // setting values for whether redemption title should be true or false
        enableCustomTitle:
          this.redemptionTitle === 'default-title' ? false : true,
        // setting values for whether redemption subtitle should be true or false
        enableCustomSubTitle: this.redemptionSubTitle !== 'default-sub-title',
        // setting values for whether redemption description should be true or false
        enableCustomDescription:
          this.redemptionDescription === 'default-description' ? false : true
      })

      this.$router.push({
        name: 'reviewOrder',
        params: { id: this.id, isEdit: this.isEdition }
      })
    },
    handleBlur(type) {
      switch (type) {
        case 'title':
          if (this.customTitle === '') {
            this.valid.title = true
          }
          break
        case 'description':
          if (this.customDescription === '') {
            this.valid.description = true
          }
          break
        case 'password':
          if (this.password === '') {
            this.valid.password = true
          }
      }
    },
    validateEmail(value) {
      // eslint-disable-next-line no-useless-escape
      return /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(
        value
      )
    },
    titleValidation() {
      let valid
      if (this.redemptionTitle === 'default-title') {
        valid = true
      } else if (
        this.redemptionTitle === 'custom-title' &&
        this.customTitle.length > 0
      ) {
        valid = true
      } else {
        valid = false
      }
      return valid
    },
    descriptionValidation() {
      let valid
      if (this.redemptionDescription === 'default-description') {
        valid = true
      } else if (
        this.redemptionDescription === 'custom-description' &&
        this.customDescription.length > 0
      ) {
        valid = true
      } else {
        valid = false
      }
      return valid
    },
    passwordValidation() {
      let valid
      if (this.passwordValue === 'no-password') {
        valid = true
      } else if (
        this.passwordValue === 'password' &&
        this.password.length > 0
      ) {
        valid = true
      } else {
        valid = false
      }
      return valid
    },
    async handleStepValidation() {
      const isTitleValid = this.$refs.GroupOrderCoverPageSettings.titleValidation()
      const isDescriptionValid = this.$refs.GroupOrderCoverPageSettings.descriptionValidation()
      if (!isTitleValid || !isDescriptionValid) {
        this.$refs.AdditionalInstruction.setAccordion(false)
        this.$refs.DataCollection.setAccordion(false)
        this.currentCustomSettingsStep = 1
        return
      }
      await this.$refs.DataCollection.updateGroupOrder()
      this.$router.push({
        name: 'GroupOrderPageAccess',
        params: { id: this.id, isEdit: this.isEdition }
      })

      // if (this.currentCustomSettingsStep === 1) {
      //   this.$refs.AdditionalInstruction.toggleAccordion()
      //   this.$refs.AdditionalInstruction.onFocusInput()
      //   this.currentCustomSettingsStep++
      // } else if (this.currentCustomSettingsStep === 2) {
      //   this.$refs.DataCollection.toggleAccordion()
      //   this.$refs.DataCollection.onFocusInput()
      //   this.currentCustomSettingsStep++
      // } else {
      //   await this.$refs.DataCollection.updateGroupOrder()
      //   this.$router.push({
      //     name: 'GroupOrderPageAccess',
      //     params: { id: this.id, isEdit: this.isEdition }
      //   })
      // }
    }
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadGroupOrder)
    },

    isEdition() {
      return this.$route.fullPath.split('/').includes('edit')
    },
    ...mapState({
      loadGroupOrder: state => state.groupOrder.loadGroupOrder,
      groupOrderDetails: state => state.groupOrder.groupOrderDetails,
      creatingGroupOrderStep: state => state.groupOrder.creatingGroupOrderStep
    }),
    validationRules() {
      return {
        customTitle: this.titleValidation(),
        customDescription: this.descriptionValidation(),
        customPassword: this.passwordValidation()
      }
    },
    disableButton() {
      return (
        Object.values(this.validationRules).includes(false) &&
        this.groupOrderDetails.state !== 'finalized'
      )
    },
    customTitleCharactersLeft() {
      if (this.customTitle) {
        return (
          this.customTitleMaxCharacters - this.customTitle.split(' ').length
        )
      } else {
        return this.customTitleMaxCharacters
      }
    },
    customDescriptionCharactersLeft() {
      if (this.customDescription) {
        return (
          this.customDescriptionMaxCharacters -
          this.customDescription.split(' ').length
        )
      } else {
        return this.customDescriptionMaxCharacters
      }
    },
    customSubtitleCharactersLeft() {
      if (this.customSubTitle) {
        return (
          this.customSubTitleMaxCharacters -
          this.customSubTitle.split(' ').length
        )
      } else {
        return this.customSubTitleMaxCharacters
      }
    }
  },
  watch: {
    customTitle(newVal) {
      if (this.customTitleCharactersLeft > 0) {
        this.customTitle = newVal
      } else {
        this.customTitle = newVal
          .split(' ')
          .splice(0, this.customTitleMaxCharacters)
          .join(' ')
      }
    },
    customDescription(newVal) {
      console.log(newVal)
      if (this.customDescriptionCharactersLeft > 0) {
        this.customDescription = newVal
      } else {
        this.customDescription = newVal
          .split(' ')
          .splice(0, this.customDescriptionMaxCharacters)
          .join(' ')
      }
    },
    customSubTitle(newVal) {
      if (this.customSubtitleCharactersLeft > 0) {
        this.customSubTitle = newVal
      } else {
        this.customSubTitle = newVal
          .split(' ')
          .splice(0, this.customSubTitleMaxCharacters)
          .join(' ')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.margin {
  margin-bottom: 1.5rem;
}

.custom-input {
  font-size: 0.813rem !important;
}

.holder {
  text-align: left;

  h3 {
    font-size: 1.063rem;
    font-family: $inter;
    color: $main-6;
    padding-bottom: 2rem;
    padding-top: 0.5rem;

    span {
      font-weight: 400;
    }
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.header-region {
  margin: 2.5rem 0;
  p {
    text-align: center;
    padding-bottom: 0.6rem;
    font-size: 1.3rem;
    font-weight: 400;
  }
}

h4 {
  text-align: left;
}
.info-container {
  margin-top: 1.25rem;
  // background-color: $dark-gray;
  border: 1px solid #232220;
  // border-bottom: none;
}
.required-info {
  margin: 2rem 0rem;
  padding: 2.5rem 2.5rem 0.5rem 2.5rem;
  display: flex;
  justify-content: space-between;

  .title {
    width: 25%;
    text-align: left;
  }

  .detail {
    width: 72%;
    p {
      font-size: 0.875rem;
      text-align: left;
      margin-bottom: 1.25rem;
    }
  }
}
.domain-container,
.password-container,
.description-container,
.title-container {
  margin: 2rem 0;
  padding: 0 2.5rem 1.75rem 2.5rem;
  display: flex;
  justify-content: space-between;

  .title {
    width: 25%;
    text-align: left;
  }

  .detail {
    width: 72%;
    .subheading {
      margin-bottom: 1rem;
    }
    p {
      text-align: left;
      font-size: 0.875rem;
      line-height: 24px;
    }
  }
}
.login-methods-container {
  margin-top: 2rem;
  padding: 0 2.5rem 0rem 2.5rem;
  display: flex;
  justify-content: space-between;

  .title {
    width: 25%;
    text-align: left;
  }

  .detail {
    width: 72%;
    .subheading {
      margin-bottom: 1rem;
    }
    p {
      text-align: left;
      font-size: 0.875rem;
      line-height: 24px;
    }
  }
}
.aditional-info {
  margin: 2rem 0rem;
  padding: 0 2.5rem;
  display: flex;
  justify-content: space-between;

  .title {
    width: 25%;
    text-align: left;
  }

  .detail {
    width: 72%;
    p {
      font-size: 0.875rem;
      text-align: left;
      margin-bottom: 1.25rem;
    }
  }

  .custom-fields {
    form {
      width: 100%;
      max-width: 14rem;
      text-align: left;
      margin-bottom: 2rem;

      &.padded {
        margin-bottom: 3rem;
      }

      .form-group {
        display: flex;
        align-items: flex-end;
        gap: 1rem;

        &.mt-3 {
          margin-top: 2rem;
        }
      }
    }

    .remove {
      cursor: pointer;
      display: block;
      width: 20px;
      user-select: none;
    }
  }

  .add-field {
    text-align: left;
    margin-bottom: 1.75rem;
    .button-gemnote--small {
      height: 2.375rem;
      text-transform: unset;
      padding: 0px 2rem !important;
      font-weight: normal;
      width: auto;

      &.custom-button {
        background: inherit;
        color: $onyx;
        text-transform: uppercase;
      }
    }
  }
}
.customize-section {
  display: grid;
  grid-template-columns: 30% 1fr;
  grid-gap: 20px;
  /* align-items: center; */
  margin-top: 19px;
  &.password {
    grid-template-columns: 9.5rem 1fr;
    margin-top: 8px;
  }
  .radio-holder {
    width: 100%;
    height: 28px;
    display: flex;
    /* align-items: center; */

    &.password {
      margin-top: 0.5rem;
    }
  }

  &.special-instruction {
    grid-template-columns: 100% 1fr !important;
  }

  textarea {
    background: inherit;
    font-family: $nunito;
    padding: 2px 0;
    width: 80%;
    display: block;
    /* margin-left: 0; */
    resize: none;
    border: none;
    border-bottom: 1px solid #24292c;
    font-size: 0.875rem;

    &.custom {
      resize: auto;
    }

    &:focus {
      outline: none;
    }

    &.error {
      border-bottom: 1px solid #da5737;
    }
  }

  .input-info-holder {
    width: 80%;
    .characters-info {
      width: max-content;
    }
    .error-text {
    }
  }

  .characters-info {
    display: block;
    position: relative;
    top: 0px;
    color: rgba(35, 34, 32, 0.5);
    font-size: 0.625rem;
    width: 80%;
    max-width: 90%;
    text-align: right;
  }
  .password-holder {
    width: 50%;
    position: relative;

    input {
      height: 1.75rem;
      padding: 2px 0;
      font-size: 0.875rem;
      background: inherit;
      font-family: $nunito;
      border: none;
      border-bottom: 1px solid #24292c;

      &.error {
        border-bottom: 1px solid #da5737;
      }
    }

    span {
      position: absolute;
      top: 9px;
      right: 0;
      font-size: 0.625rem;
      color: #676767;
      cursor: pointer;
    }
  }

  ::placeholder {
    color: #9b9b9b;
    font-size: 0.75rem;
  }
  .error-text {
    color: #da5737;
    font-size: 10px;
  }
}
.row {
  display: flex;
  text-align: left;
  flex-wrap: wrap;
  justify-content: space-between;

  .row-holder {
    width: 33.3%;
    &.first {
      width: 25%;
    }
  }
}

.field {
  font-weight: 700;
  margin: 0.5rem 0;
  font-size: 0.813rem;
}

.button-area {
  margin-top: 3rem;
  display: flex;
  justify-content: center;

  button {
    padding: 0 2rem !important;
    width: auto;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.domain-content {
  /* display: grid;
  grid-template-columns: 170px 1fr;
  margin-bottom: 2rem; */
  grid-gap: 1rem;
  p {
    margin-top: 0.8rem;
    text-align: left;
  }
}
.allow-domains {
  width: 100%;
}

.title p {
  font-size: 0.938rem;
}

.detail p {
  font-size: 0.813rem !important;
}

@media (max-width: 1100px) {
  .required-info {
    flex-direction: column;
    padding: 2rem;
    transition: 1s ease-in;

    .title {
      width: 100%;
      p {
        margin-bottom: 1rem;
      }
    }

    .detail {
      width: 100%;
    }
  }

  .aditional-info {
    flex-direction: column;
    padding: 2rem;
    transition: 1s ease-in;

    .title {
      width: 100%;
      p {
        margin-bottom: 1rem;
      }
    }

    .detail {
      width: 100%;
    }
  }

  .field {
    flex-basis: 50%;
  }

  .row {
    .row-holder {
      width: 100%;
      &.first {
        width: 100%;
      }
    }
  }
}

@media (max-width: 800px) {
  .required-info,
  .aditional-info {
    padding: 1rem;
  }
  .login-methods-container,
  .title-container,
  .description-container {
    padding: 0 1rem 0rem 1rem;
  }
  .customize-section {
    display: block;
  }
  .custom-block {
    display: block;
    .title {
      width: 100%;
    }
  }
  .detail {
    width: 100% !important;
  }
  .domain-container {
    display: block;
  }
  .customize-section .password-holder {
    width: 100%;
  }
}
@media (min-width: 1024px) {
  .info-container {
    margin-left: 3rem;
  }
}
</style>
